class MultiPermissionsDecorator {
  hasPermission (userDetails, ...validPermissions) {
    console.debug('Checking multiPermissions')
    const finalValidPermissions = ['MASTER', ...validPermissions]
    return userDetails.permissions.some(p => finalValidPermissions.includes(p))
  }
}

export default new MultiPermissionsDecorator()
